<script setup lang="ts">
import BookingStepper from "@/components/booking/bookingStepper.vue";
import { bookingGlobalPopupStore } from "@/components/booking/bookingGlobalPopupStore";
import { storeToRefs } from "pinia";
const { getUserList,
  closeDialog,
  deleteBooking,
  handleRefetchingData } = bookingGlobalPopupStore()
const { isBookingStepperVisible,
  editBookingData,
  recurringDetails,
  activityList,
  listArea,
  usersList,
  locationList,
  currentLocation,
  getMyRole,
  userInfo,
  userId,
  globalSetup,
  permissionListMap, isEditing } = storeToRefs(bookingGlobalPopupStore())
</script>
<template>
  <BookingStepper
    v-model:isDrawerOpen="isBookingStepperVisible"
    :booking="editBookingData"
    :recurring-details="recurringDetails"
    :activity-list="activityList"
    :area-list="listArea"
    :memberList="usersList"
    :location-list="locationList"
    :current-location="currentLocation"
    :current-logged-in-roles="getMyRole"
    :membership="userInfo?.expand?.membership"
    :user-id="userId"
    :permission="permissionListMap?.bookings ?? []"
    :coupon-value="globalSetup?.couponValue"
    @loadUsersList="getUserList()"
    @update:isDrawerOpen="closeDialog"
    @delete-booking="deleteBooking($event)"
    @isEditing="isEditing=true"
    @refetchBookingData="handleRefetchingData"
    @closeDialog="closeDialog"
  />
</template>
